import { theme } from '@/styles';
import { AgentRhKbBadges } from '@/types';
import GridListBox from '@/ui/GridListBox';
import QuoteEndIcon from '@/ui/Icons/QuoteEndIcon';
import QuoteStartIcon from '@/ui/Icons/QuoteStartIcon';
import Image from '@/ui/Image';
import React from 'react';
import styled from 'styled-components';

interface BadgesProps {
  data: AgentRhKbBadges[];
  title: string;
}

const Badges = ({ title, data }: BadgesProps) => {
  return (
    <GridListBox
      title={title}
      isTooltip
      isArrow={false}
      spaceBetween={16}
      tooltip={{
        title: '시공 고객 평가란?',
        text: '해당 대리점에서 리모델링 시공을 받은 고객님들의 평가를 종합한 내용입니다.',
      }}
      gridNum={2}
      imgList={data}
      gtmName="shop_construction_customer_evaluation"
    >
      {({ item, index }: any) => (
        <BadgeContainer>
          <Image
            src={item.imageUrl}
            width="44px"
            height={'44px'}
            alt="badgesIcon"
          />
          <BadgeTitleContainer>
            <QuoteStartIcon />
            <BadgeTitle>{item.text}</BadgeTitle>
            <QuoteEndIcon />
          </BadgeTitleContainer>
          <BadgeDescriptionContainer>
            {item.description.map((_: string, idx: number) => (
              <BadgeDescription key={`description_${idx}`}>
                {_}
              </BadgeDescription>
            ))}
          </BadgeDescriptionContainer>
        </BadgeContainer>
      )}
    </GridListBox>
  );
};

export default Badges;

const BadgeContainer = styled.div`
  width: 100%;
  height: 217px;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  align-items: center;
`;

const BadgeTitleContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 16px;
  display: flex;
`;

const BadgeTitle = styled.div`
  padding-left: 26px;
  padding-right: 30px;
  color: ${theme.colors.accent_colors.primary.default};
  ${theme.typography.subtitle4};
`;

const BadgeDescriptionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
`;

const BadgeDescription = styled.div`
  color: ${theme.colors.neutral_colors.gray[700]};
  ${theme.typography.body1};
`;
